export const WEB_TITLE = "The Unicorn Club";
